module.exports = __webpack_public_path__ + "static/img/7.1b41b57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/7.jpg
// module id = POte
// module chunks = 1